import { render, staticRenderFns } from "./PendingSubjects.vue?vue&type=template&id=f58ab90c&scoped=true"
import script from "./PendingSubjects.vue?vue&type=script&lang=js"
export * from "./PendingSubjects.vue?vue&type=script&lang=js"
import style0 from "./PendingSubjects.vue?vue&type=style&index=0&id=f58ab90c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58ab90c",
  null
  
)

export default component.exports